import {
  IcoCheckCircle,
  IcoCheckCircle2,
  IcoLoader,
  IcoClock,
  IcoXCircle,
  IcoSliders,
  IcoX,
} from "./icons";

const STATUS_CONDITION_FIELD_OPTIONS = [
  { value: "dcr", label: "DCR" },
  { value: "subscription", label: "Subscription" },
  { value: "consent", label: "Consent" },
];

// ─── Auto Processed Filter Bar + Panel ─────────────────────────────────────

export default function AutoProcessFilters({
  disabled = false,
  filterOpen,
  setFilterOpen,
  hasFilters,
  filterRS,
  setFilterRS,
  filterSource,
  setFilterSource,
  counts,
  subFilters,
  activeSubs,
  addSubFilter,
  removeSubFilter,
  updateSubFilter,
  setAutoPage,
  onClearAll,
}) {
  return (
    <>
      {/* Filter bar + summary */}
      <div className="rc-fbar">
        <button
          className={`rc-ftog${filterOpen ? " open" : ""}${hasFilters ? " fil" : ""}`}
          onClick={() => setFilterOpen((o) => !o)}
          disabled={disabled}
          title={filterOpen ? "Close filters" : "Open filters"}
        >
          <IcoSliders />
          {hasFilters && (
            <span className="rc-fcount">
              {filterRS.size + filterSource.size + activeSubs.length}
            </span>
          )}
        </button>
        <div className="rc-cboxes">
          {[
            {
              k: "total",
              lbl: "Total",
              n: counts.total,
              icon: <IcoCheckCircle cls="ic-na" size={13} />,
            },
            {
              k: "done",
              lbl: "Processed",
              n: counts.processed,
              icon: <IcoCheckCircle2 cls="ic-c" size={13} />,
            },
            {
              k: "prog",
              lbl: "In Progress",
              n: counts.in_progress,
              icon: <IcoLoader cls="ic-ip" size={13} />,
            },
            {
              k: "pend",
              lbl: "Pending",
              n: counts.pending,
              icon: <IcoClock cls="ic-p" size={13} />,
            },
            {
              k: "fail",
              lbl: "Failed",
              n: counts.failed,
              icon: <IcoXCircle cls="ic-f" size={13} />,
            },
          ].map(({ k, lbl, n, icon }) => (
            <div key={k} className={`rc-cbox ${k}`}>
              <div style={{ flexShrink: 0 }}>{icon}</div>
              <div>
                {/* <p className="rc-cbox-num">{n}</p>
                <p className="rc-cbox-lbl">{lbl}</p> */}
                 <p className="rc-cbox-lbl" style={{fontSize: "12px"}}>{lbl} : <span style={{fontWeight: "bold"}}>{n}</span></p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Filter panel */}
      {filterOpen && (
        <div
          className="rc-fp"
          style={
            disabled ? { opacity: 0.5, pointerEvents: "none" } : undefined
          }
          aria-disabled={disabled}
        >
          <div className="rc-fp-in">
            <div className="rc-fp-sec">
              <p className="rc-fp-ttl">Result Status</p>
              <div className="rc-schks">
                {[
                  { v: "pending", lbl: "Pending", dot: "pend" },
                  { v: "in_progress", lbl: "In Progress", dot: "prog" },
                  { v: "processed", lbl: "Processed", dot: "done" },
                  { v: "failed", lbl: "Failed", dot: "fail" },
                ].map(({ v, lbl, dot }) => {
                  const on = filterRS.has(v);
                  return (
                    <label key={v} className={`rc-schk${on ? " on" : ""}`}>
                      <input
                        type="checkbox"
                        checked={on}
                        onChange={() => {
                          setFilterRS((prev) => {
                            const n = new Set(prev);
                            on ? n.delete(v) : n.add(v);
                            return n;
                          });
                          setAutoPage(1);
                        }}
                      />
                      <span className={`rc-schk-dot ${dot}`} />
                      {lbl}
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="rc-fp-div" />

            <div className="rc-fp-sec">
              <p className="rc-fp-ttl">Source</p>
              <div className="rc-schks">
                {[
                  { v: "eph", lbl: "EPH", dot: "eph" },
                  { v: "vendor", lbl: "Vendor", dot: "vendor" },
                  { v: "not_found", lbl: "Not Found", dot: "nf" },
                ].map(({ v, lbl, dot }) => {
                  const on = filterSource.has(v);
                  return (
                    <label key={v} className={`rc-schk${on ? " on" : ""}`}>
                      <input
                        type="checkbox"
                        checked={on}
                        onChange={() => {
                          setFilterSource((prev) => {
                            const n = new Set(prev);
                            on ? n.delete(v) : n.add(v);
                            return n;
                          });
                          setAutoPage(1);
                        }}
                      />
                      <span className={`rc-schk-dot ${dot}`} />
                      {lbl}
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="rc-fp-div" />

            <div className="rc-fp-sec full">
              <div className="rc-cond-hdr">
                <p className="rc-fp-ttl" style={{ margin: 0 }}>
                  Status Conditions
                </p>
                <button
                  className="rc-add-cond"
                  onClick={addSubFilter}
                  disabled={subFilters.length >= STATUS_CONDITION_FIELD_OPTIONS.length}
                >
                  + Add condition
                </button>
              </div>
              {subFilters.length === 0 ? (
                <p className="rc-no-cond">
                  No conditions — click "+ Add condition" to filter by DCR,
                  Subscription or Consent status.
                </p>
              ) : (
                <div className="rc-conds">
                  {subFilters.map((sf, idx) => {
                    // A field already picked by another row can't be picked again.
                    const usedByOthers = new Set(
                      subFilters
                        .filter((x) => x.id !== sf.id)
                        .map((x) => x.field),
                    );
                    const fieldOptions = STATUS_CONDITION_FIELD_OPTIONS.filter(
                      (opt) => opt.value === sf.field || !usedByOthers.has(opt.value),
                    );
                    return (
                    <div key={sf.id} className="rc-cond">
                      {idx > 0 && <span className="rc-cond-and">AND</span>}
                      <select
                        value={sf.field}
                        onChange={(e) =>
                          updateSubFilter(sf.id, {
                            field: e.target.value,
                            value: "",
                          })
                        }
                      >
                        {fieldOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      <span className="rc-cond-eq">=</span>
                      <select
                        className={sf.value ? "val" : ""}
                        value={sf.value}
                        onChange={(e) => {
                          updateSubFilter(sf.id, { value: e.target.value });
                          setAutoPage(1);
                        }}
                      >
                        <option value="">Select…</option>
                        <option value="applicable">Applicable</option>
                        <option value="not_applicable">Not Applicable</option>
                        <option value="pending">Pending</option>
                        <option value="in_progress">In Progress</option>
                        <option value="completed">Completed</option>
                        <option value="failed">Failed</option>
                      </select>
                      <button
                        className="rc-cond-rm"
                        onClick={() => {
                          removeSubFilter(sf.id);
                          setAutoPage(1);
                        }}
                      >
                        <IcoX size={11} />
                      </button>
                    </div>
                    );
                  })}
                </div>
              )}
            </div>

            {hasFilters && (
              <button className="rc-clear" onClick={onClearAll}>
                <IcoX size={11} /> Clear all
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
